// extracted by mini-css-extract-plugin
export default {"MaxPanel":"MaxPanel_MaxPanel__tvOnG","buttonsPanel":"MaxPanel_buttonsPanel__1alZF"};